import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import theme from '../../styles/theme';
const headerStyles = css `
  text-align: left;
  padding: ${theme.spacing.x3};
`;
const defaultProps = {
    className: '',
};
const TableHeader = ({ children, className = defaultProps.className, }) => (_jsx("th", Object.assign({ className: className, css: [
        theme.typeStyles.bodyBoldStyles,
        headerStyles,
    ] }, { children: _jsx("span", Object.assign({ css: css `
          vertical-align: middle;
        ` }, { children: children })) })));
const MemoizedTableHeader = memo(TableHeader);
export { MemoizedTableHeader as TableHeader };
// MC-1068 Temporary hack for Storybook.
export default TableHeader;
